import React from 'react'
import TLink from '../../transitions/TLink'
import "./styles.scss"

const CTA = ({text, linkText, linkURL}) => {
  return (
    <section className="section section--cta">
      <div className="wrapper">
        <div className="cta-box">
          <p className="cta-box__text">{text}</p>
          <TLink className={`btn btn--bordered`} to={linkURL}>
            {linkText}
          </TLink>
        </div>
      </div>
    </section>
  )
}

export default CTA
